import { css } from '@emotion/react';

export const containerStyle = css`
	height: 100vh;
	width: 100vw;
	background: #fff;
`;

export const headerStyle = css`
	${containerStyle};
	height: 6.59%;
	display: flex;
	align-items: center;
	padding: 0 100px;
	border-bottom: 1px solid #d1d1d1;
	@media (max-width: 768px) {
		padding: 0 50px;
	}
`;

export const contentStyle = css`
	${containerStyle};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const footerStyle = css`
	${containerStyle};
	height: 10%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	border-top: 3px solid #d1d1d1;
	@media (max-width: 768px) {
			height: 5%;
		}
`;

export const logoStyle = css`
	height: 54.2%;
`;

export const bigTextStyle = css`
	font-size: 28px;
	font-family: 'Noto Sans TC', sans-serif;
	@media (max-width: 768px) {
		font-size: 24px;
	}
`;

export const textStyle = css`
	font-size: 16px;
	font-family: 'Noto Sans TC', sans-serif;
	margin: 8px 0;
	@media (max-width: 768px) {
		font-size: 12px;
	}
`;

export const textStyle_TC = css`
	${textStyle};
	font-family: 'Microsoft JhengHei', sans-serif;
`;

export const grayTextStyle = css`
	${textStyle};
	color: #878787;
`;

export const buttonStyle = css`
  	margin: 16px 0;
`;